import styled from 'styled-components';

export default styled.div`
  display: inline;
  font-size: 1.2rem;
  color: #505058;
  margin: 0.5rem 1rem 0 0;
  float: right;

  ${props => props.thisStyles}
`;
